import { render } from "./Statistics.vue?vue&type=template&id=1be257c0"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=1be257c0&lang=scss"
script.render = render

export default script